<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.forum.candidateValLost.p1')}}
    <a href="#">{{news.textParams[0]}}
      {{$t('news.template.forum.candidateValLost.p2')}}
    </a>
    {{$t('news.template.forum.candidateValLost.p3')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[1]}}"
    >{{news.textParams[2]}} {{news.textParams[3]}}</router-link>
    {{$t('news.template.forum.candidateValLost.p4')}}
    {{news.textParams[4]}} - {{news.textParams[5]}}.
  </div>
</template>
